var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-select',{staticClass:"noline filterTitle",attrs:{"items":_vm.getFilters,"menu-props":{
      bottom: true,
      offsetY: true
    },"item-text":"title","item-value":"filterConfigId","return-object":""},model:{value:(_vm.selectedFilter),callback:function ($$v) {_vm.selectedFilter=$$v},expression:"selectedFilter"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }